import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '../models';
import { API } from '../../shared/constants/app-service-constants';

@Injectable()
export class UserService {
  constructor(private http: HttpClient) {}

  getCurrentUserData(): Observable<User> {
    return this.http.get<any>(API.CURRENT_USER).pipe(map((res) => res['data'] as User));
  }

  createNewUser(params: User): Observable<any> {
    return this.http.post(API.SIGN_UP, params);
  }

  updateUserData(params): Observable<any> {
    const newUserData = (({ firstName, lastName, emailAddress, password }) => ({
      firstName,
      lastName,
      emailAddress,
      password,
    }))(params);

    return this.http.put<any>(API.SIGN_UP, newUserData).pipe(map((res) => res['UserDto']));
  }
}
